// extracted by mini-css-extract-plugin
module.exports = {"floorSelector":"styles_floorSelector__1X4kw","title":"styles_title__1f9_4","floorBtn":"styles_floorBtn__20deI","active":"styles_active__1RbvU"};